import {useState} from "react";
import {useAuth} from "../context/AuthContext";
import {Link, useNavigate} from "react-router-dom";
import PushNotificationBell from "./PushNotificationBell";

export default function Navbar({ onMenuClick }) {
    const {logout, user} = useAuth();
    const navigate = useNavigate();
    const initial  = user?.email?.[0]?.toUpperCase() || "U";
    const [q, setQ] = useState("");

    const handleSearch = (e) => {
        e.preventDefault();
        const term = q.trim();
        if (term.length < 2) return;
        navigate(`/search?q=${encodeURIComponent(term)}`);
        setQ("");
    };

    return (
        <nav className="navbar app-navbar px-3 d-flex align-items-center gap-3">
            <button className="btn btn-link p-0 d-md-none text-dark" onClick={onMenuClick} aria-label="Menu">
                <i className="bi bi-list" style={{fontSize: "1.4rem"}} />
            </button>
            <form onSubmit={handleSearch} className="d-flex align-items-center gap-2 flex-grow-1" style={{maxWidth: 420}}>
                <div className="input-group input-group-sm">
                    <span className="input-group-text bg-white border-end-0">
                        <i className="bi bi-search text-muted"/>
                    </span>
                    <input
                        className="form-control border-start-0 ps-0"
                        placeholder="Search everything…"
                        value={q}
                        onChange={e => setQ(e.target.value)}
                    />
                </div>
            </form>

            <div className="d-flex align-items-center gap-3 ms-auto">
                <PushNotificationBell />
                <span className="small text-muted d-none d-md-inline">{user?.email}</span>
                <Link to="/user" className="user-avatar text-decoration-none">{initial}</Link>
                <button onClick={logout} className="btn btn-sm btn-outline-secondary">
                    <i className="bi bi-box-arrow-right"/>
                    <span className="d-none d-md-inline ms-1">Logout</span>
                </button>
            </div>
        </nav>
    );
}
